 document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  initVariantPickers();
  initProductGalleries();
});

function initProductGalleries() {
  document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbsWrap = gallery.querySelector('[data-gallery-thumbs]');
    if (!main) return;
    var slides = main.querySelectorAll('.pdp-gallery__slide');
    var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('.pdp-gallery__thumb') : [];

    function matchHeightTo(index) {
      var img = slides[index] ? slides[index].querySelector('img') : null;
      if (!img) return;
      var apply = function () { main.style.height = img.offsetHeight + 'px'; };
      if (img.complete) {
        apply();
      } else {
        img.addEventListener('load', apply, { once: true });
      }
    }

    function setActive(index) {
      thumbs.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
      });
      if (thumbs[index]) {
        thumbs[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
      matchHeightTo(index);
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });

    gallery.addEventListener('pdp:show-image', function (e) {
      var index = e.detail && typeof e.detail.index === 'number' ? e.detail.index : null;
      if (index === null || !slides[index]) return;
      slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    });

    var scrollTimer;
    main.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var index = Math.round(main.scrollLeft / main.clientWidth);
        setActive(index);
      }, 100);
    });

    window.addEventListener('resize', function () {
      var index = Math.round(main.scrollLeft / main.clientWidth);
      matchHeightTo(index);
    });

    matchHeightTo(0);
  });
}

function initVariantPickers() {
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var variants = JSON.parse(picker.dataset.productJson);
    var idInput = picker.querySelector('[data-variant-id]');
    var form = picker.closest('form');
    var priceEl = document.getElementById('ProductPrice');
    var addToCartBtn = form ? form.querySelector('[data-add-to-cart]') : null;
    var unavailableMsg = form ? form.querySelector('[data-variant-unavailable]') : null;

    function selectedOptions() {
      var groups = picker.querySelectorAll('[data-option-index]');
      var values = [];
      groups.forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    function findMatchingVariant() {
      var selected = selectedOptions();
      return variants.find(function (variant) {
        return selected.every(function (value, index) {
          return value === null || variant.options[index] === value;
        });
      });
    }

    function updateUI() {
      var match = findMatchingVariant();
      picker.querySelectorAll('label.pill').forEach(function (label) {
        var input = label.querySelector('input[type="radio"]');
        label.classList.toggle('is-active', input.checked);
      });
      if (match) {
        idInput.value = match.id;
        if (priceEl) {
          priceEl.textContent = (match.price / 100).toLocaleString(undefined, { style: 'currency', currency: window.shopCurrency || 'USD' });
        }
                if (addToCartBtn && addToCartBtn.dataset.comingSoon !== 'true') {
          addToCartBtn.disabled = !match.available;
          addToCartBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
        if (unavailableMsg) unavailableMsg.style.display = 'none';
        if (match.featured_image) {
          var gallery = document.querySelector('[data-pdp-gallery]');
          if (gallery) {
            gallery.dispatchEvent(new CustomEvent('pdp:show-image', {
              detail: { index: match.featured_image.position - 1 }
            }));
          }
        }
      } else {
        if (addToCartBtn) addToCartBtn.disabled = true;
        if (unavailableMsg) unavailableMsg.style.display = 'block';
      }
    }

    picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', updateUI);
    });

    updateUI();
  });
}